import { DigestType as DigestTypeApi } from '@wix/ambassador-individual-scheduling-assistant-v1-digest/types';
import { validateProps } from '../../utils/PropsValidationUtils';
import { isValidBase } from '../BaseEntity';
export { DigestTypeApi };
export let DigestType = /*#__PURE__*/function (DigestType) {
  DigestType["UNKNOWN_DIGEST_TYPE"] = "UNKNOWN_DIGEST_TYPE";
  DigestType["TASK"] = "TASK";
  DigestType["TASK_PROGRESS"] = "TASK_PROGRESS";
  DigestType["TASK_PLAN"] = "TASK_PLAN";
  // Deprecated
  DigestType["ROUTINE"] = "ROUTINE";
  DigestType["CATEGORY"] = "CATEGORY";
  DigestType["BRAIN_CONVERSATION"] = "BRAIN_CONVERSATION";
  return DigestType;
}({});
export let DigestedTaskStatus = /*#__PURE__*/function (DigestedTaskStatus) {
  DigestedTaskStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
  DigestedTaskStatus["COMPLETED"] = "COMPLETED";
  DigestedTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
  DigestedTaskStatus["PAUSED"] = "PAUSED";
  DigestedTaskStatus["WAITING"] = "WAITING";
  return DigestedTaskStatus;
}({});
export let IndividualTaskType = /*#__PURE__*/function (IndividualTaskType) {
  IndividualTaskType["MESSAGE"] = "MESSAGE";
  IndividualTaskType["MEETING"] = "MEETING";
  IndividualTaskType["REMINDER"] = "REMINDER";
  return IndividualTaskType;
}({});
export function isValidDigest(digest) {
  return isValidBase(digest) && validateProps(digest, ['type', 'data']);
}
//# sourceMappingURL=Digest.js.map